import TlSetDriverCardModal from './tl-set-driver-card-modal.vue'
export default TlSetDriverCardModal
